import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

import { useTheme } from '@material-ui/core/styles';
import { makeStyles } from '@material-ui/core/styles';

import { userOnLogin } from 'lib/api/user';
import { showSuccessSnackbar } from 'modules/snackbar';
import {
  creativeList,
  creativeListQltyBoard,
  creativeListFreeView,
} from 'lib/api/creative';
import {
  makeHeadData,
  getHeadObj,
  makeRowColumn,
  converUpDown,
  converParameters,
  getHost,
} from 'lib/commonLib';
import { setPortal } from 'modules/portal';
import { paramConverter } from 'modules/common';

import CurrentStatus from 'components/atoms/CurrentStatus';
import NewButton from 'components/molecules/NewButton';
import TableBtnWrap from 'components/molecules/TableBtnWrap';
import NewTableContainer from 'components/molecules/NewTable';
import NewFilterWrap from 'components/molecules/NewFilterWrap';
import SortLabelWrap from 'components/molecules/MbTable/SortLabelWrap';
import SpanningTableContents from 'components/molecules/MbTable/SpanningTableContents';
import Modal from 'components/organisms/NewModal';
import NewCommonFilter from 'components/organisms/NewCommonFilter';
import FilterCollection from 'components/organisms/FilterCollection';

const useStyles = makeStyles((theme) => ({
  colorBarWrap: { display: 'flex', justifyContent: 'center' },
  colorBar: { width: 10, height: 20, marginRight: 10 },
  spanningBox: { width: 80 },
}));

const Statistics = (props) => {
  const { devLocation } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const theme = useTheme();
  const classes = useStyles();

  const { portal } = useSelector(({ portal }) => ({ portal: portal }));

  const handlePortalUrl = (url) => {
    let newPortal = portal.portal;
    let popIndex = newPortal.length;
    newPortal[popIndex] = { url: url, cnt: popIndex };
    dispatch(setPortal(newPortal));
  };
  const [initialization, setInitialization] = useState(false);
  const initParams = {
    sort: 'desc',
    order: 'LAST_UPDATE',
    sDate: moment().add(-13, 'day').format('YYYYMMDD'),
    eDate: moment().add(-7, 'day').format('YYYYMMDD'),
    diffSDate: moment().add(-6, 'day').format('YYYYMMDD'),
    diffEDate: moment().format('YYYYMMDD'),
    pltfomTpCode: 'all',
    adGrpTpCode: 'all',
    abFlag: 'all',
    qltyCode: 'all',
    // advrtsPrdtCode: '',
    // advrtsTpCode: '',
    // pfmKey: '',
    // pfmCode: '',
    // pfmVal: '',
    // lastUpdate: '',
    // keyword: '',
    // uri: '',
  };
  const [tempParams, setTempParams] = useState(initParams);
  const [params, setParams] = useState(initParams);
  const [boardData, setBoardData] = useState([]);
  const [boardLoading, setBoardLoading] = useState('loading');
  const initModal = { open: false, type: null, params: {}, data: [] };
  const [modal, setModal] = useState(initModal);
  const [presets, setPresets] = useState([]);

  const initCustomized = {
    GUBUN: { orderFlag: true },
    ADVER_NAME: { orderFlag: true },
    GRP_NAME: { orderFlag: true },
    MOBON_AD_GRP_ID: { merged: true },
    QLTY_CODE: { merged: true },
    CLICK_CNT: { merged: true },
    CLICK_RATE: { merged: true },
    ADVRTS_AMT: { merged: true },
    SESSION_CONV_CNT: { merged: true },
    SESSION_CONV_AMT: { merged: true },
    SESSION_ROAS: { merged: true },
    DIFF_CLICK_CNT: { merged: true },
    DIFF_CLICK_RATE: { merged: true },
    DIFF_ADVRTS_AMT: { merged: true },
    DIFF_SESSION_CONV_CNT: { merged: true },
    DIFF_SESSION_CONV_AMT: { merged: true },
    DIFF_SESSION_ROAS: { merged: true },
    RVS_RAF_RATE_PAR_EPRS_CNT: { merged: true },
    RVS_RAF_RATE_CLICK_CNT: { merged: true },
    RVS_RAF_RATE_CLICK_RATE: { merged: true },
    RVS_RAF_RATE_ADVRTS_AMT: { merged: true },
    RVS_RAF_RATE_SESSION_CONV_CNT: { merged: true },
    RVS_RAF_RATE_SESSION_CONV_AMT: { merged: true },
    RVS_RAF_RATE_SESSION_ROAS: { merged: true },
    LAST_UPDATE: { orderFlag: true },
  };

  const [customized, setCustomized] = useState({});
  const [boardCustomized, setBoardCustomized] = useState({});

  let tableHeadList = [
    {
      id: 'TYPE1_RESULT',
      label: t('소재'),
      orderFlag: false,
      type: 'string',
      format: '@',
      displayFlag: true,
    },
    {
      id: 'TYPE2_RESULT',
      label: t('하위'),
      orderFlag: false,
      type: 'string',
      format: '@',
      displayFlag: true,
    },
  ];

  const boardKeys = ['RESULT', 'TOP', 'MIDDLE', 'BOTTOM'];

  const keys = [
    'PAR_EPRS_CNT',
    'CLICK_CNT',
    'CLICK_RATE',
    'ADVRTS_AMT',
    'SESSION_CONV_CNT',
    'SESSION_CONV_AMT',
    'SESSION_ROAS',
  ];

  const diffPresets = [
    {
      text: t('오늘'),
      start: moment(),
      end: moment(),
    },
    {
      text: t('어제'),
      start: moment().add(-1, 'day'),
      end: moment().add(-1, 'day'),
    },
    {
      text: t('이번달'),
      start: moment().startOf('month'),
      end: moment(),
    },
    {
      text: t('전월'),
      start: moment().add(-1, 'month').startOf('month'),
      end: moment().add(-1, 'month').endOf('month'),
    },
    {
      text: t('전전월'),
      start: moment().add(-2, 'month').startOf('month'),
      end: moment().add(-2, 'month').endOf('month'),
    },
    {
      text: t('최근 7일'),
      start: moment().add(-7, 'day'),
      end: moment().add(-1, 'day'),
    },
    {
      text: t('최근 30일'),
      start: moment().add(-30, 'day'),
      end: moment().add(-1, 'day'),
    },
    {
      text: t('최근 90일'),
      start: moment().add(-90, 'day'),
      end: moment().add(-1, 'day'),
    },
    {
      text: t('최근 180일'),
      start: moment().add(-180, 'day'),
      end: moment().add(-1, 'day'),
    },
  ];

  /**
   * 필터 초기화 후 값을 바꿈
   */
  useEffect(() => {
    if (initialization === true) {
      setInitialization(false);
    } // eslint-disable-next-line
  }, [initialization]);

  useEffect(() => {
    handleDate(initParams);
    handleGetBoard();
    handleCustomized(params);
    // eslint-disable-next-line
  }, []);

  /**
   * 필터 초기화
   */
  const handleOnReset = () => {
    if (
      JSON.stringify(params) !== JSON.stringify(initParams) ||
      JSON.stringify(tempParams) !== JSON.stringify(initParams)
    ) {
      setInitialization(true);
      setParams(initParams);
      setTempParams(initParams);
    }
  };

  const getParam = () => {
    if (JSON.stringify(params) !== JSON.stringify(tempParams)) {
      setParams(tempParams);
      handleCustomized(tempParams);
    }
  };

  const handleGetParam = (newParams) => {
    // 테이블에서 사용하는 별도 함수
    if (JSON.stringify(params) !== JSON.stringify(newParams)) {
      setParams(newParams);
      setTempParams(newParams);
      handleCustomized(newParams);
    }
  };

  const getTempParam = (newParams) => {
    if (JSON.stringify(tempParams) !== JSON.stringify(newParams)) {
      setTempParams(newParams);
      handleDate(newParams);
    }
  };

  const handleGetBoard = () => {
    setBoardLoading('loading');
    creativeListQltyBoard({ params: paramConverter(params) })
      .then((response) => {
        const { data } = response.data;
        let newData = {};
        for (let key in data) {
          if (key === '01') {
            newData = {
              ...newData,
              TYPE1_RESULT: data[key]['00'],
              TYPE1_TOP: data[key]['01'],
              TYPE1_MIDDLE: data[key]['02'],
              TYPE1_BOTTOM: data[key]['03'],
            };
          } else if (key === '02') {
            newData = {
              ...newData,
              TYPE2_RESULT: data[key]['00'],
              TYPE2_TOP: data[key]['01'],
              TYPE2_MIDDLE: data[key]['02'],
              TYPE2_BOTTOM: data[key]['03'],
            };
          }
        }
        setBoardData([{ ...newData }]);
        const tableKey = ['TYPE1_RESULT', 'TYPE2_RESULT'];
        let newCustomized = {};
        for (let key of tableKey) {
          newCustomized[key] = {
            makeHead: (headsMap) => {
              const result = [];
              for (let i = 0; i < boardKeys.length; i++) {
                let headLabel = '';
                let color = '';
                if (boardKeys[i] === 'RESULT') {
                  headLabel = t('합계');
                  result.push(
                    <div key={boardKeys[i]} className={classes.spanningBox}>
                      {headLabel}
                    </div>
                  );
                } else if (boardKeys[i] === 'TOP') {
                  headLabel = t('상위');
                  color = theme.palette.common.green;
                } else if (boardKeys[i] === 'MIDDLE') {
                  headLabel = t('중위');
                  color = theme.palette.common.orange;
                } else if (boardKeys[i] === 'BOTTOM') {
                  headLabel = t('하위');
                  color = theme.palette.common.red;
                }
                if (boardKeys[i] !== 'RESULT') {
                  result.push(
                    <div key={boardKeys[i]} className={classes.spanningBox}>
                      <div
                        className={classes.colorBarWrap}
                        style={{ color: color }}
                      >
                        ■ {headLabel}
                      </div>
                    </div>
                  );
                }
              }
              return (
                <SpanningTableContents
                  topTitle={key === 'TYPE1_RESULT' ? t('소재') : t('카피')}
                  type="head"
                >
                  {result}
                </SpanningTableContents>
              );
            },
            makeBody: (rowObj, headsMap) => {
              let result = [];
              const keyName = key === 'TYPE1_RESULT' ? 'TYPE1' : 'TYPE2';
              for (let i = 0; i < boardKeys.length; i++) {
                result.push(
                  <div key={boardKeys[i]} className={classes.spanningBox}>
                    {makeRowColumn(
                      rowObj[keyName + '_' + boardKeys[i]],
                      'number',
                      '#,##0'
                    )}
                  </div>
                );
              }
              return <SpanningTableContents>{result}</SpanningTableContents>;
            },
            orderFlag: false,
            headStyle: { borderRight: '1px solid #e5e8eb' },
            bodyStyle: { borderRight: '1px solid #e5e8eb' },
          };
        }
        setBoardCustomized(newCustomized);
      })
      .catch((error) => {
        handleClickSnackbar({ message: error, option: { type: 'error' } });
        setBoardLoading('error');
      })
      .finally(() => {
        setBoardLoading('');
      });
  };

  const handleCustomized = (propsParams) => {
    let newCustomized = {
      MANAGE_ICONS: {
        makeBody: (rowObj, headsMap) => {
          let barColor;
          const qltyCode = rowObj['QLTY_CODE'];
          if (qltyCode === '03') {
            barColor = theme.palette.common.red;
          } else if (qltyCode === '02') {
            barColor = theme.palette.common.orange;
          } else if (qltyCode === '01') {
            barColor = theme.palette.common.green;
          } else {
            barColor = theme.palette.common.gray3;
          }
          const LinkShowWindowUrl = converParameters({
            url: '/report/creative/detail',
            mobonAdGrpId: rowObj['MOBON_AD_GRP_ID'],
            adverIds: rowObj['ADVER_ID'],
            sDate: propsParams.diffSDate,
            eDate: propsParams.diffEDate,
            isPop: 1,
          });
          return (
            <TableBtnWrap>
              <div
                className={classes.colorBar}
                style={{ height: 28, background: barColor }}
              />
              <NewButton
                title={t('미리보기')}
                iconBtn
                icon="faImages"
                onClick={(e) => handleModalFreeView(rowObj['MOBON_AD_GRP_ID'])}
                disableRipple
              />
              <NewButton
                title={t('수정')}
                iconBtn
                icon="faEdit"
                onClick={(e) => handleOnLogin(rowObj)}
                disableRipple
              />
              <NewButton
                title={t('연결')}
                iconBtn
                icon="faLink"
                disableRipple
                onClick={(e) => handlePortalUrl(LinkShowWindowUrl)}
              />
            </TableBtnWrap>
          );
        },
      },
      AB_FLAG: {
        makeHead: (headsMap) => {
          return t('A/B 테스트');
        },
        makeBody: (rowObj, headsMap) => {
          const showWindowUrl = converParameters({
            url: getHost('new') + '/report/creative/abTest',
            mobonAdGrpId: rowObj['MOBON_AD_GRP_ID'],
            adverIds: rowObj['ADVER_ID'],
            isPop: 1,
            sDate: propsParams.diffSDate,
            eDate: propsParams.diffEDate,
          });
          return (
            rowObj['AB_FLAG'] === '01' && (
              <NewButton
                name="priceEdit"
                title={t('A/B 테스트')}
                iconBtn
                icon="faSpellCheck"
                disableRipple
                onClick={(e) => handlePortalUrl(showWindowUrl)}
              />
            )
          );
        },
      },
      PAR_EPRS_CNT: {
        makeHead: (headsMap) => {
          const result = [];
          for (let i = 0; i < keys.length; i++) {
            result.push(
              <div key={keys[i]} className={classes.spanningBox}>
                <SortLabelWrap
                  params={propsParams}
                  label={
                    keys[i] === 'SESSION_ROAS'
                      ? t('세션') + ' ROAS'
                      : getHeadObj(headsMap, keys[i]).label
                  }
                  orderKey={keys[i]}
                  onClick={(e) => handleSortChange(keys[i], propsParams)}
                />
              </div>
            );
          }
          return (
            <SpanningTableContents topTitle={t('기준일')} type="head">
              {result}
            </SpanningTableContents>
          );
        },
        makeBody: (rowObj, headsMap) => {
          let result = [];
          for (let i = 0; i < keys.length; i++) {
            result.push(
              <div
                key={keys[i]}
                className={classes.spanningBox}
                style={{
                  color:
                    keys[i] === 'CLICK_RATE'
                      ? theme.palette.common.blue
                      : keys[i] === 'ADVRTS_AMT'
                      ? theme.palette.common.red
                      : keys[i] === 'SESSION_ROAS' && theme.palette.common.purple,
                }}
              >
                {makeRowColumn(
                  rowObj[keys[i]],
                  getHeadObj(headsMap, keys[i]).type,
                  getHeadObj(headsMap, keys[i]).format
                )}
              </div>
            );
          }
          return <SpanningTableContents>{result}</SpanningTableContents>;
        },
        orderFlag: false,
        headStyle: {
          borderLeft: '1px solid #e5e8eb',
          borderRight: '1px solid #e5e8eb',
        },
        bodyStyle: {
          borderLeft: '1px solid #e5e8eb',
          borderRight: '1px solid #e5e8eb',
        },
      },
      DIFF_PAR_EPRS_CNT: {
        makeHead: (headsMap) => {
          const result = [];
          for (let i = 0; i < keys.length; i++) {
            result.push(
              <div key={keys[i]} className={classes.spanningBox}>
                <SortLabelWrap
                  params={propsParams}
                  label={
                    keys[i] === 'SESSION_ROAS'
                      ? t('세션') + ' ROAS'
                      : getHeadObj(headsMap, keys[i]).label
                  }
                  orderKey={'DIFF_' + keys[i]}
                  onClick={(e) =>
                    handleSortChange('DIFF_' + keys[i], propsParams)
                  }
                />
              </div>
            );
          }
          return (
            <SpanningTableContents topTitle={t('비교일')} type="head">
              {result}
            </SpanningTableContents>
          );
        },
        makeBody: (rowObj, headsMap) => {
          let result = [];
          for (let i = 0; i < keys.length; i++) {
            result.push(
              <div key={keys[i]} className={classes.spanningBox}>
                <span
                  style={{
                    color:
                      keys[i] === 'CLICK_RATE'
                        ? theme.palette.common.blue
                        : keys[i] === 'ADVRTS_AMT'
                        ? theme.palette.common.red
                        : keys[i] === 'SESSION_ROAS' && theme.palette.common.purple,
                  }}
                >
                  {makeRowColumn(
                    rowObj['DIFF_' + keys[i]],
                    getHeadObj(headsMap, 'DIFF_' + keys[i]).type,
                    getHeadObj(headsMap, 'DIFF_' + keys[i]).format
                  )}
                </span>
                <br />
                {converUpDown(
                  rowObj['RVS_RAF_RATE_' + keys[i]],
                  getHeadObj(headsMap, 'RVS_RAF_RATE_' + keys[i]).type,
                  getHeadObj(headsMap, 'RVS_RAF_RATE_' + keys[i]).format
                )}
              </div>
            );
          }
          return <SpanningTableContents>{result}</SpanningTableContents>;
        },
        orderFlag: false,
        headStyle: { borderRight: '1px solid #e5e8eb' },
        bodyStyle: { borderRight: '1px solid #e5e8eb' },
      },
    };
    setCustomized({ ...initCustomized, ...newCustomized });
  };

  const handleDate = (newParams) => {
    const t1 = moment(newParams['diffSDate']);
    const t2 = moment(newParams['diffEDate']);
    const diffCnt = moment.duration(t2.diff(t1)).asDays() + 1;
    const newPresets = [
      {
        text: t('이전기간'),
        start: moment(newParams.diffSDate).add(-+diffCnt, 'day'),
        end: moment(newParams.diffSDate).add(-1, 'day'),
      },
      {
        text: t('이전연도'),
        start: moment(newParams.diffSDate).add(-1, 'year'),
        end: moment(newParams.diffEDate).add(-1, 'year'),
      },
    ];
    setPresets(newPresets);
  };

  /**
   * 테이블 컬럼 추가
   */
  const addColumnList = (() => {
    const result = new Map();
    result.set(0, {
      id: 'MANAGE_ICONS',
      label: t('관리'),
      align: 'center',
      makeRowFunc: (rowObj) => {
        return 'MANAGE_ICONS';
      },
    });
    return result;
  })();

  const handleSortChange = (orderKey, propsParams) => {
    const { order, sort } = propsParams;
    const isDesc = order === orderKey && sort === 'desc';
    const converSort = isDesc ? 'asc' : 'desc';
    const newParams = { ...propsParams, order: orderKey, sort: converSort };
    setParams(newParams);
    setTempParams(newParams);
    handleCustomized(newParams);
  };

  const handleModalClose = () => {
    setModal({ ...modal, open: false });
  };

  const handleModalFreeView = (groupId) => {
    let newModal = {
      ...initModal,
      open: true,
      type: 'freeView',
      cancelBtnTitle: t('닫기'),
      headerTitle: t('미리보기'),
    };
    creativeListFreeView({ params: { mobonAdGrpId: groupId } })
      .then((response) => {
        const { data } = response.data;
        newModal = { ...newModal, data: data };
      })
      .catch((error) => {
        handleClickSnackbar({ message: error, option: { type: 'error' } });
      })
      .finally(() => {
        setModal(newModal);
      });
  };

  const handleOnLogin = (rowData) => {
    const showWindowUrl = converParameters({
      url:
        rowData['GUBUN'] === '소재'
          ? devLocation + '/creative/static_manage_form'
          : rowData['GUBUN'] === '카피' &&
            devLocation + '/creative/copy_manage_form',
      adGrpTpCode:
        rowData['GUBUN'] === '소재'
          ? '01'
          : rowData['GUBUN'] === '카피' && '02',
      grpId: rowData['MOBON_AD_GRP_ID'],
    });

    userOnLogin(rowData['ADVER_ID'], 'manage', showWindowUrl)
      .then((response) => {
        const { data, success } = response.data;
        if (success) {
          handlePortalUrl(data.url);
        } else {
          handleClickSnackbar({
            message: t('로그인에 실패했습니다. 관리자에게 문의하세요.'),
            option: { type: 'error' },
          });
        }
      })
      .catch((error) => {
        handleClickSnackbar({ message: error, option: { type: 'error' } });
      });
  };

  const handleClickSnackbar = useCallback((snackbarOptions) => {
    dispatch(showSuccessSnackbar(snackbarOptions));
    //eslint-disable-next-line
  }, []);

  return (
    <>
      <NewFilterWrap handleOnReset={handleOnReset}>
        <NewCommonFilter
          initialization={initialization}
          getParam={getTempParam}
          params={tempParams}
          useExternalFilter={false}
          useDiffDate
          customPresets={presets}
          diffCustomPresets={diffPresets}
          dateLabel={t('기준일')}
          diffDateLabel={t('비교일')}
        />
        <FilterCollection
          label={t('품질지수')}
          value={tempParams.contact}
          name="qltyCode"
          type="select"
          params={tempParams}
          list={[
            { label: t('전체'), value: 'all' },
            { label: t('상위') + '(10~8)', value: '01' },
            { label: t('중위') + '(7~4)', value: '02' },
            { label: t('하위') + '(3~1)', value: '03' },
          ]}
          labelKey="label"
          valueKey="value"
          callBack={getTempParam}
        />
        <FilterCollection
          label={t('구분')}
          value={tempParams.contact}
          name="adGrpTpCode"
          type="select"
          params={tempParams}
          list={[
            { label: t('전체'), value: 'all' },
            { label: t('일반소재'), value: '01' },
            { label: t('카피'), value: '02' },
          ]}
          labelKey="label"
          valueKey="value"
          callBack={getTempParam}
        />
        <FilterCollection
          label={t('A/B 테스트')}
          value={tempParams.contact}
          name="abFlag"
          type="select"
          params={tempParams}
          list={[
            { label: t('전체'), value: 'all' },
            { label: t('진행중'), value: '01' },
            { label: t('미진행'), value: '02' },
          ]}
          labelKey="label"
          valueKey="value"
          callBack={getTempParam}
        />
        <NewButton onClick={getParam}>{t('검색')}</NewButton>
      </NewFilterWrap>
      {boardLoading !== 'loading' && boardData.length > 0 ? (
        <div style={{ display: 'flex', justifyContent: 'end' }}>
          <div style={{ width: 800 }}>
            <NewTableContainer
              params={params}
              getParam={handleGetParam}
              useFetch={false}
              useTotal={false}
              propsList={boardData}
              propsHeadCells={makeHeadData(tableHeadList)}
              useCustomTable
              loading={false}
              useStoreLoading={false}
              usePagenation={false}
              useToolBar={false}
              reFetch={false}
              customized={boardCustomized}
            />
          </div>
        </div>
      ) : (
        <CurrentStatus type={boardLoading} />
      )}
      <NewTableContainer
        params={params}
        getParam={handleGetParam}
        dataReqPromise={creativeList}
        customized={customized}
        rowsPerPage={-1}
        usePagenation={false}
        useTotal={false}
        addColumnList={addColumnList}
        excelItemsRemoval="mobonAdGrpId,gubun,abFlag,qltyCode"
        // callBack={() => handleCustomized()}
      />
      <Modal
        open={modal.open}
        headerTitle={modal.headerTitle}
        confirmBtnOpen={modal.type !== 'freeView'}
        cancelBtnTitle={modal.cancelBtnTitle}
        handleClose={handleModalClose}
        style={{ minWidth: 400 }}
      >
        {modal.type === 'freeView' && (
          <>
            {modal.data.images.map((image, i) => (
              <div key={i}>
                <h6 className={classes.imgTitle}>{image['IMG_INFO']}</h6>
                <div>
                  <img
                    src={'http://img.mobon.net/ad/imgfile/' + image['IMG_PATH']}
                    alt={image['IMG_INFO']}
                    style={{ maxWidth: 500 }}
                  />
                </div>
              </div>
            ))}
            {modal.data.cps.map((cps, i) => (
              <p key={i}>
                {t('카피문구')}({i + 1}) : {cps['CP_INFO']} /{' '}
                {cps['CP_INFO'].length} {t('자')}
              </p>
            ))}
          </>
        )}
      </Modal>
    </>
  );
};

export default Statistics;
